import React from "react";
import { useNavigate } from "react-router-dom";
import { IconButton } from "@chakra-ui/react";

import Breadcrumb from "../Breadcrumb/Breadcrumb";

import page_back_left_arrow from "../../assets/images/icons/page_back_left_arrow.png";

export default function PageDetailHeader(props) {
  const handleBackPage = () => {
    navigate(-1);
  };

  const { breadCrumbList, heading } = props;

  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-2">
      <div className="ml-[3.1rem]">
        <Breadcrumb list={breadCrumbList} />
      </div>
      <div className="flex flex-row gap-2">
        <div>
          <IconButton
            variant="ghost"
            icon={<img src={page_back_left_arrow} />}
            onClick={handleBackPage}
          />
        </div>
        <h1 className="font-raleway  ">{heading}</h1>
      </div>
    </div>
  );
}
